import React from 'react';

import { PriceInput } from 'components/shared/PriceInput';

const PriceInputField = ({
  field,
  form,
  ...restProps
}: { field: any; form: any } & Record<string, any>) => (
  <PriceInput {...field} {...restProps} />
);

export default React.memo(PriceInputField) as any;
